<template>
  <span class="font-display font-black italic uppercase leading-none tracking-tight select-none" :class="sizes[size]">
    <span class="text-white">Calvo</span><span class="text-brand">bet</span>
  </span>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  size: {
    type: String,
    default: 'md'
  }
});

const sizes = {
  sm: 'text-2xl',
  md: 'text-3xl',
  lg: 'text-5xl',
};
</script>
